import API from './axios.js';

export const getAllExistPlans = (queryParams='') => API.get(`/plans${queryParams}`);
export const getExistPlanByID = (id) => API.get(`super-admin/plans/${id}`);
export const addPlan = (data) => API.post(`super-admin/plans`,data);
export const updatePlan = (id,payload) => API.put(`super-admin/plans/${id}`,payload);
export const deletePlan = (id) => API.delete(`super-admin/plans/${id}`);


export const companyaddeditcourtdetails = (id,payload) => API.post(`super-admin/company/court-details/${id}`,payload);



export const getAllUsersForSuperAdmin = (queryParams= '') => API.get(`super-admin/user${queryParams}`);
export const addUserBySuperAdmin = (data) => API.post(`super-admin/user`,data);
export const updateUserBySuperAdmin = (id,payload) => API.put(`super-admin/user/${id}`,payload);
export const deleteUserBySuperAdmin = (id) => API.delete(`super-admin/user/${id}`);



export const getAllCompaniesForSuperAdmin = (queryParams='') => API.get(`super-admin/company${queryParams}`);
export const getCompanyByID = (company_id) => API.get(`company/${company_id}`);
export const addCompanyBySuperAdmin = (payload) => API.post(`super-admin/company`,payload);
export const updateCompanyBySuperAdmin = (id,payload) => API.put(`super-admin/company/${id}`,payload);
export const deleteCompany = (id) => API.delete(`super-admin/company/${id}`);

export const hcScrapingSync = (id) => API.get(`scraper/high-court/by-company/${id}`);
export const getHcScrapingStatus = () => API.get(`super-admin/company/hc-scraping-status`);


export const dcScrapingSync = (id) => API.get(`scraper/district-court/by-company/${id}`);
export const getDcScrapingStatus = () => API.get(`super-admin/company/dc-scraping-status`);



export const SearchGetAllExistPlans = (input) => API.get(`super-admin/plans?search=${input}`);
export const SearchGetAllUsersForSuperAdmin = (input) => API.get(`super-admin/user?search=${input}`);
export const SearchGetAllCompaniesForSuperAdmin = (input) => API.get(`super-admin/company?search=${input}`);

export const getPlanRightsByID = (id) => API.get(`super-admin/plans/${id}`);
export const getAllRightsEdit = (company_id) => API.get(`super-admin/company-rights/${company_id}`);

export const getUserRightsEdit = (user_id) => API.get(`super-admin/user-rights/${user_id}`);

export const createPaymentOrder = (planId, companyId) => API.get(`payment/order?planId=${planId}&companyId=${companyId}`);

export const getCustomRights = (companyId) => API.get(`super-admin/rights-override/${companyId}`);

export const createOrUpdateCustomRights = (payload) => API.put(`super-admin/rights-override`,payload);

